import MainLayout from "@/components/layout/company/MainLayout.vue";
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
    name: "companyJobRequestDetail",

    components: {
        MainLayout,
    },

    data() {
        return {
            jobRequestApplicantDetail: {}
        };
    },

    computed: {
        ...mapGetters({ isCompanyLoggedIn: "isCompanyLoggedIn", companyToken: "companyToken" })
    },

    methods: {
        getJobRequestApplicantInfo() {
            axios.get("company/job_request/detail/" + this.$route.params.id)
                .then(response => {
                    if (!response.data || response.data.length === 0) {
                        this.$router.push({ name: "notFound" });
                        return;
                    }
                    this.jobRequestApplicantDetail = response.data;
                })
                .catch(error => {
                    console.log("Job Request Detail API error", error);
                    this.$router.push({ name: "notFound" });
                });
        },

        setMoment(date) {
            if (!date) return '';
            return moment(date).fromNow();
        }
    },
    
    mounted() {
        this.getJobRequestApplicantInfo();
    }
};